
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as ProfileIcon } from "../fontello/icons/svg/ic_profile.svg"


const Profile = ({ ...props }) => (
  <SvgIcon
    component={ProfileIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Profile
